import { IntersectionFade } from "../components/IntersectionFade";

const STATS = [
  { value: "<20ms",  label: "Edge manifest\nlatency via Workers KV" },
  { value: "~10×",   label: "Faster than legacy\npoll-based players" },
  { value: "100%",   label: "Offline playback\nwhen cache is warm" },
  { value: "<1s",    label: "Push propagation\nvia Durable Objects" },
] as const;

const PERF_POINTS = [
  {
    title: "Workers KV manifest caching",
    detail: "Cloudflare's globally distributed key-value store serves manifest JSON at the edge — no origin round-trip.",
  },
  {
    title: "Content-addressed R2 + CDN",
    detail: "Media files are named by sha256 hash and served via Cloudflare's global CDN. Identical assets never transfer twice.",
  },
  {
    title: "WebSocket push, not polling",
    detail: "KSP sends a push message the instant content is published. Screens react in under a second, not a minute.",
  },
  {
    title: "Durable Objects coordination",
    detail: "A singleton DeviceHub DO holds every screen's WebSocket. Fan-out to thousands of devices happens in one hop.",
  },
] as const;

export function Performance() {
  return (
    <section className="section perf-section" id="performance" aria-labelledby="perf-heading">
      <div className="container">
        <div className="perf-content">
          {/* Left: copy + list */}
          <div>
            <IntersectionFade direction="left">
              <span className="eyebrow">Performance</span>
              <h2 className="h2 mb-16" id="perf-heading">
                Built for the{" "}
                <span className="grad-text">edge era</span>
              </h2>
              <p className="lead">
                Kynetra runs on Cloudflare Workers, Durable Objects, R2, and KV — the fastest runtime distribution
                on the planet. Legacy signage polls a single server. We push from the edge.
              </p>
            </IntersectionFade>

            <ul className="perf-list" aria-label="Performance architecture details">
              {PERF_POINTS.map(({ title, detail }, i) => (
                <IntersectionFade key={title} delay={i * 80} direction="left">
                  <li className="perf-list-item">
                    <span className="perf-list-bullet" aria-hidden="true">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </span>
                    <div className="perf-list-text">
                      <strong>{title}</strong>
                      <span>{detail}</span>
                    </div>
                  </li>
                </IntersectionFade>
              ))}
            </ul>
          </div>

          {/* Right: stat tiles */}
          <div className="perf-stat-grid" aria-label="Performance metrics">
            {STATS.map(({ value, label }, i) => (
              <IntersectionFade key={value} delay={i * 80} direction="right">
                <div className="glass-card perf-stat-card">
                  <div className="perf-stat-value grad-text">{value}</div>
                  <div className="perf-stat-label" style={{ whiteSpace: "pre-line" }}>{label}</div>
                </div>
              </IntersectionFade>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
